import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { useState, useEffect } from 'react';
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { useLocation } from 'react-router-dom';

import Swal from 'sweetalert2';


import { useSelector } from "react-redux";


export default function FiberTeam({ stock, setStock, installDetails, setinstallDetails, isSubmitting }) {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;

  const locate = useLocation();
  const staffName = useSelector((state) => state.staffname);
  console.log(installDetails)

  const [materialInput, setMaterialInput] = useState({
    material: "",
    materialType: "",
    unit: "",
  });


useEffect(() => {
  console.log("Updated materialsSelected:", installDetails?.workAssign?.fiberTeam?.materialsSelected);
}, [installDetails]);


  // useEffect(() => {
  //   axios
  //     .post(apiUrl + "getdata-install", {
  //       leadId: locate.state?.leadId,
  //     })
  //     .then((res) => {
  //       setinstallDetails(res.data.message);
  //     });
  // }, [locate.state?.leadId]);

  const [unitFiberTeam, setUnitFiberTeam] = useState(0);
  const [materialFetch, setMaterialFetch] = useState([]);


  const incrementUnitFiberTeam = () => {
    setUnitFiberTeam(prevUnit => prevUnit + 1);
  };

  const handleMaterialInputChange = (e) => {
    const { name, value } = e.target;

    const numericFields = ["unit", "sellingCost"];

    setMaterialInput((prev) => ({
      ...prev,
      [name]: numericFields.includes(name) ? Number(value) : value,
    }));
  };


  const handleRemoveMaterial = (index) => {
    const updated = [...stock.materials];
    updated.splice(index, 1);
    setStock((prev) => ({
      ...prev,
      materials: updated,
    }));
  };

  const filteredMaterialTypes = materialInput.material
    ? materialFetch.filter((d) => d.material === materialInput.material)
    : [];

  const addMaterialToStock = () => {
    console.log("addMaterialToStock");

    const { material, materialType, unit, sellingCost } = materialInput;

    if (!material || !materialType || !unit) {
      toast.error("Please fill in all material fields before adding.");
      return;
    }

    const isDuplicate = stock.materials.some(
      (item) => item.materialRequire === material && item.materilType === materialType
    );

    if (isDuplicate) {
      toast.warning("This material with the same type is already added.");
      return;
    }

    const newMaterial = {
      materialRequire: material,
      materialType: materialType,
      unit,


    };

    // Update `stock.materials`
    setStock((prev) => ({
      ...prev,
      materials: [...prev.materials, newMaterial],
    }));

    // Update `installDetails.workAssign.fiberTeam`
    // setinstallDetails((prev) => ({
    //   ...prev,
    //   workAssign: {
    //     ...prev.workAssign,
    //     fiberTeam: Array.isArray(prev.workAssign?.fiberTeam)
    //       ? [...prev.workAssign.fiberTeam, newMaterial]
    //       : [newMaterial],
    //   },
    // }));

    // Clear input fields
    setMaterialInput({
      material: "",
      materialType: "",
      unit: "",
      sellingCost: "",
    });

    console.log("New Material Added to FiberTeam and Materials");
  };


  const planMonth = Number(installDetails?.installplanDetails?.installplanMonth) || 0;
  const planAmount = Number(installDetails?.installplanDetails?.installplanAmount) || 0;
  const staticIpCost = Number(installDetails?.installplanDetails?.installstaticIpCost) || 0;
  const installationCost = Number(installDetails?.installplanDetails?.installinstalationCost) || 0;
  const routerCost = Number(installDetails?.installplanDetails?.installrouterCost) || 0;
  const otherCost = Number(installDetails?.installplanDetails?.installothersCost) || 0;

  const totalPlanAmount = planMonth * planAmount;

  const baseAmount = totalPlanAmount + staticIpCost + installationCost + routerCost + otherCost;

  const gstAmount = baseAmount * 0.18;

  const orderValue = +(baseAmount + gstAmount).toFixed(2);


  const formattedOrderValue = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR"
  }).format(orderValue);


  useEffect(() => {
    const fetchStockDropdownMaterials = async () => {
      try {
        const response = await axios.get(`${apiUrl}/manage-stock/get-all`);
        setMaterialFetch(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        console.log("error", error);
      }
    };

    fetchStockDropdownMaterials();
  }, [apiUrl]);

  



  const plan = installDetails.installplanDetails || {};


  const installrouterCost = Number(plan.routerSellingCost) || 0;
  const installfiberCost = Number(plan.installfiberCost) || 0;
  const installfiberCableMeter = Number(plan.installfiberCableMeter) || 0;
  const installottPrice = Array.isArray(plan.installottPrice) ? Number(plan.installottPrice[0]) || 0 : 0;
  const installothersCost = Number(plan.installothersCost) || 0;
  const OrderScore = baseAmount
    - installrouterCost
    - (installfiberCableMeter * installfiberCost)
    - installottPrice
    - installothersCost;

  console.log("OrderScore:", OrderScore);
  console.log(baseAmount, 'baseamout')

  const formattedOrderScore = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR"
  }).format(OrderScore);

  console.log(installDetails)

const handleSubmit = async (e) => {
  e.preventDefault();

   if (!stock.materials || stock.materials.length === 0) {
    return Swal.fire({
      icon: "warning",
      title: "Please select at least one material",
    });
  }


  const result = await Swal.fire({
    title: "Update the changes?",
    showCancelButton: true,
    confirmButtonText: "Update",
  });

  if (!result.isConfirmed) return;

  try {
    const now = new Date();
    const day = String(now.getDate()).padStart(2, "0");
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const year = now.getFullYear();
    const updatedDate = `${day}-${month}-${year}`;
    let hours = now.getHours();
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    const updatedTime = `${hours}:${minutes} ${ampm}`;

    const prevFiberTeam = installDetails?.workAssign?.fiberTeam || {};
    const prevMaterials = prevFiberTeam.materials || [];
    const newMaterials = stock.materials || [];

    const updatedFiberTeam = {
      ...prevFiberTeam,
      ...stock,
      materials: [...prevMaterials, ...newMaterials],
      materialsSelected: true,
    };

    const updatedInstall = {
      ...installDetails,
      workAssign: {
        ...installDetails.workAssign,
        fiberTeam: updatedFiberTeam,
      },
    };


    // 🔵 Send to backend
    await axios.post(apiUrl + "update-lead-install", updatedInstall, {
      headers: { "Content-Type": "application/json" },
    });

    // ✅ Update local state so button disappears
    setinstallDetails(updatedInstall);

    Swal.fire("Success!", "Data updated successfully", "success");

  } catch (error) {
    Swal.fire("Error", error.response?.data?.message || "Something went wrong!", "error");
  }
};





// Your form (make sure this comes *after* handleSubmit is declared)



  return (
    <div>
      <Container className='fiberteam-container'>
        {/* <form onSubmit={()=>handleSubmit()}> */}


          <Row>

            <Col md={9} sm={9}>

             <div className='plan-details-container-border mt-3 text-center'>
            <p style={{ fontSize: "13px" }} className='pt-2'><span className='text-primary'>{installDetails?.installplanDetails?.installfiberCableMeter}
            </span> M, <span className='text-primary '>{installDetails?.installplanDetails?.installplanSpeed}
              </span> Mbps, <span className='text-primary'> {installDetails?.installplanDetails?.installplanMonth}</span>Month @ <span className='text-primary'>Rs. {installDetails?.installplanDetails?.installplanAmount}
                /-</span></p>
            <p style={{ fontSize: "13px" }}>Order Value @ <span className='text-primary'>Rs.{formattedOrderValue}/-</span>, OrderScore @ <span className='text-primary'>Rs.{formattedOrderScore}/-</span></p>

          </div>
            </Col>

            {(installDetails?.workAssign?.fiberTeam?.materialsSelected !==true && installDetails.leadStatus!=="Cancelled" )  &&(
               <Col md={3} sm={3}>

             <button  onClick={(e) => handleSubmit(e)} className='blue-btn'>Submit</button>
            </Col>
            )}
            
          </Row>

         




          {/* <div className='mt-5 mb-4' >
            <Row className='fiber-team-assignedby pt-1  ms-1 '>
              <p className='ms-5'>Assigned By<span className='text-primary'> Ravikumar</span><span className='ms-5'>  Assigned Date </span><span className='text-primary'> 12/12/2024</span></p>
            </Row>
          </div> */}
          {/* <label><strong> Staff Name</strong></label> */}
          {/* <div className='staff-name-fiberteam mt-3 mb-3'>
            <Row className='fiber-team-work-container'><Col md={3} sm={3}>
              <div className='fiber-team-name'>

                <p>Shanmugam</p>
              </div>

            </Col>
              <Col md={3} sm={3}>
                <div className='fiber-team-name' >
                  <p>vimal</p>
                </div>
              </Col>
            </Row>
          </div> */}



          {/* <div className='fiber-team-fiber-container mt-3 mb-4'>
  <Row className='mt-2'>
    {Array.isArray(installDetails?.workAssign?.fiberTeam) &&
      installDetails.workAssign.fiberTeam.map((team, teamIndex) => (
        <React.Fragment key={teamIndex}>
          {team.materialRequire ? (
            <Col key={`${teamIndex}`} xs={12} sm={6} md={4} className="mb-2">
              <div className="d-flex align-items-center justify-content-between p-2 rounded shadow-sm">
                <span>
                  {team.materialRequire} (<span>{team.materialType}</span>) -{" "}
                  <span className='text-primary'>{team.unit}</span>
                </span>
              </div>
            </Col>
          ) : null}
        </React.Fragment>
      ))}
  </Row>
</div> */}

          {Array.isArray(installDetails?.workAssign?.fiberTeam?.materials) &&
            installDetails?.workAssign?.fiberTeam?.materials?.length > 0 && (
              <div>
                <h6 className='mt-4'>Added Materials</h6>
                <div className='fiber-team-fiber-container mt-3 mb-4'>


                  <Row className='mt-2'>
                    {installDetails.workAssign.fiberTeam.materials.map((team, teamIndex) => (
                      <Col key={`${teamIndex}`} xs={12} sm={6} md={4} className="mb-2">
                        <div className="d-flex align-items-center justify-content-between p-2 rounded shadow-sm">
                          <span>
                            {team.materialRequire} (<span>{team.materialType}</span>) -{" "}
                            <span className='text-primary'>{team.unit}</span>
                          </span>
                        </div>
                      </Col>
                    ))}
                  </Row>
                </div>
              </div>
            )}






          {/* <Row  className='mb-5'>
  <Col md={3} sm={3}>
  <label>Materials Required</label>
  <br/>
  <select
        
          class="dropbtn form-input-select overlay2"
          >
         <option value="">Select</option>
          <option
        className="onlineback"

        value="Online"
        >
         Online
        </option>
         <option className="offlineback" value="Offline">
         Offline
         </option>
      </select>
  
  </Col>
  <Col md={3} sm={3}>
  <label>
    Unit</label>
    <br/>
    <input 
    className='form-input text-center'
    value={unitFiberTeam} readOnly 
    />


    
    </Col>
    <Col sm={1} md={1} className='text-start'>
    
<button type="button" className='increment-btn-fiber bg-primary' onClick={incrementUnitFiberTeam}><strong><span style={{fontSize:"20px"}}>+</span></strong></button>
    
    </Col>
</Row> */}
{(
  !(installDetails?.workAssign?.fiberTeam?.materials?.length > 0) ||
  installDetails?.workAssign?.fiberTeam?.approvedStatus ==="Resubmit"
) && (
            <Row>
              {stock.materials.length > 0 && (
                <>
                  <h6 className="add-material">Added Materials</h6>
                  <Col xs={12} className="mt-1 mb-2 border-container-plus1">
                    {stock.materials.map((mat, index) => (
                      <div
                        key={index}
                        className="d-flex justify-content-between align-items-center bg-white border rounded p-2 mb-2"
                      >
                        <div className="fw-bold">
                          <span>
                            {mat.materialRequire} ({mat.materialType}) •{" "}
                          </span>
                          <span className="text-primary">
                            {["2F", "4F", "6F", "Cat 6 Cable"].includes(mat.materilType)
                              ? `${mat.unit} M`
                              : mat.unit}
                          </span>
                        </div>

                        <button
                          type="button"
                          className="btn btn-sm btn-outline-secondary"
                          onClick={() => handleRemoveMaterial(index)}
                        >
                          <span style={{ fontSize: "20px" }}> ×</span>
                        </button>
                      </div>
                    ))}
                  </Col>
                </>
              )}


              <Col xs={12} md={6} className="text-start">
                <Row className="mt-3">
                  <Col xs={12} md={6} className="text-start">
                    <label className="">Materials</label>
                    <br />
                    <select
                      className="dropbtn form-input-select"
                      name="material"
                      value={materialInput.material}
                      onChange={handleMaterialInputChange}
                    >
                      <option value="">Select Material</option>
                      {[...new Set(materialFetch.map((d) => d.material))].map(
                        (material, i) => (
                          <option key={i} value={material}>
                            {material}
                          </option>
                        )
                      )}
                    </select>
                  </Col>
                  <Col xs={12} md={6} className="text-start">
                    {stock.materials && ( // Show only if materials is selected
                      <>
                        <label className="">Material Types</label>
                        <br />
                        <select
                          className="dropbtn form-input-select"
                          name="materialType"
                          value={materialInput.materialType}
                          onChange={handleMaterialInputChange}
                        >
                          <option value="">Select Material Type</option>
                          {filteredMaterialTypes.map((d, i) => (
                            <option key={i} value={d.materialType}>
                              {d.materialType}
                            </option>
                          ))}
                        </select>
                      </>
                    )}
                  </Col>
                </Row>
              </Col>

              <Col xs={12} md={6} className="text-start">
                <Row className="mt-3">
                  <Col xs={12} md={6} className="text-start">
                    <label className="">Unit</label>
                    <br />
                    <input
                      className="form-input"
                      type="number"
                      onKeyDown={(e) => {
                        if (
                          ["e", "E", "+", "-"].includes(e.key) ||
                          (e.key &&
                            !/[0-9]/.test(e.key) &&
                            e.key !== "Backspace" &&
                            e.key !== "ArrowLeft" &&
                            e.key !== "ArrowRight")
                        ) {
                          e.preventDefault();
                        }
                      }}
                      name="unit"
                      value={materialInput.unit}
                      onChange={handleMaterialInputChange}
                    />
                  </Col>



                  <Col xs={12} md={2} className="text-start mt-3">

                    <br />
                    <button
                      type="button"
                      onClick={() => addMaterialToStock()}
                      className="blue-btn plus-blue-btn"
                      style={{ fontSize: "20px" }}
                    >
                      +
                    </button>
                  </Col>
                </Row>

              </Col>

            </Row>


          )}

        {/* </form> */}
      </Container>

    </div>
  )
}
